import apiClient from './apiClient';

const paymentGatewaysService = {
  getGateways: async () => {
    const response = await apiClient.get('/settings/payment-gateways');
    return response.data;
  },

  connect: async (gateway, { publicKey, secretKey, mode }) => {
    const response = await apiClient.post(`/settings/payment-gateways/${gateway}/connect`, { publicKey, secretKey, mode });
    return response.data;
  },

  configure: async (gateway, { publicKey, secretKey, mode }) => {
    const response = await apiClient.put(`/settings/payment-gateways/${gateway}/configure`, { publicKey, secretKey, mode });
    return response.data;
  },

  disconnect: async (gateway) => {
    const response = await apiClient.delete(`/settings/payment-gateways/${gateway}/disconnect`);
    return response.data;
  },

  toggle: async (gateway) => {
    const response = await apiClient.patch(`/settings/payment-gateways/${gateway}/toggle`);
    return response.data;
  },
};

export default paymentGatewaysService;
